var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 2.01071L13.9893 0.5L8 6.48929L2.01071 0.5L0.5 2.01071L6.48929 8L0.5 13.9893L2.01071 15.5L8 9.51071L13.9893 15.5L15.5 13.9893L9.51071 8L15.5 2.01071Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 2.01071L13.9893 0.5L8 6.48929L2.01071 0.5L0.5 2.01071L6.48929 8L0.5 13.9893L2.01071 15.5L8 9.51071L13.9893 15.5L15.5 13.9893L9.51071 8L15.5 2.01071Z",
  fill: "#636766"
})));
export { SvgCloseCross as ReactComponent };
export default __webpack_public_path__ + "96eb5c06ecce3d5a1b77c1ab927329bb.svg";